var ssg = ssg || {};
ssg.View = ssg.View || {};
ssg.Event = ssg.Event || {};
ssg.Event.emitter = {
    subscribers: {},
    on: function (event, cb, context) {
        this.subscribers[event] = this.subscribers[event] || [ ];
        this.subscribers[event].push({
            callback: cb,
            context: context
        });
    },
    off: function (event, cb, context) {
        var idx, subs = this.subscribers[event], sub;
        if (subs) {
            idx = subs.length - 1;
            while (idx >= 0) {
                sub = subs[idx];
                if (sub.callback === cb && (!context || sub.context === context)) {
                    subs.splice(idx, 1);
                    break;
                }
                idx--;
            }
        }
    },
    emit: function (event) {
        var subs = this.subscribers[event], idx = 0, args = Array.prototype.slice.call(arguments, 1), sub;
        if (subs) {
            while (idx < subs.length) {
                sub = subs[idx];
                sub.callback.apply(sub.context || this, args);
                idx++;
            }
        }
    }
};